import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { GOOGLE_ANALYTICS_SCOPES, useCreateAuthMutation } from "src/context/api/google/api";

interface GoogleAuthUser {
    email: string;
    scopes: GOOGLE_ANALYTICS_SCOPES[];
}


const useIntegrators = (baseUsersList: GoogleAuthUser[] = []) => {
    const [users, setUsers] = useState<GoogleAuthUser[]>(baseUsersList);
    const [sendInvitations] = useCreateAuthMutation();
    const sendAuthInviation = (user: GoogleAuthUser) => {
        sendInvitations({
            target: user.email,
            grant: user.scopes,
            wp_id: 1,
        })
        .unwrap()
        .then(() => {
            enqueueSnackbar("Invitation sent to " + user.email, { variant: "success" });
        })
        .catch((error) => {
            enqueueSnackbar("Error sending invitation to " + user.email, { variant: "error" });
        });
    }

    useEffect(() => {
        if (baseUsersList && baseUsersList.length > 0) {
            setUsers(baseUsersList);
        }
    }, [baseUsersList]);
    
    
    return {
        users: {
            list: users,
            set: setUsers,
            add: (user: any) => setUsers([...users, user]),
            remove: (user: any) => setUsers(users.filter((u) => u.email !== user)),
            addScopes: (user: any, scopes: GOOGLE_ANALYTICS_SCOPES[]) => setUsers(users.map((u) => u.email === user.email ? { ...u, scopes: [...u.scopes, ...scopes] } : u)),
        },
        trigger() {
            users.forEach(sendAuthInviation);
        }
    };
}

export default useIntegrators;